import {throttle} from "./Util";
import {disactiveHover} from "./Persons.js";

/**
 * Главная страница
 * ***/

const $mainSlider = $('.js-main-slider');
const $container = $('.js-main-slider-wrap');
const $mainSliderPagintaion = $('.main-slider-pagination .slider-pagination-wrap');
const $textPagination = $container.find('.js-main-slider-text-pagination');
const slidesCount = $container.find('.slide').length;
const $numbersSlider = $('.js-numbers-slider');
const $prevBtnCursor = $container.find('.js-slider-prev-cursor');
const $nextBtnCursor = $container.find('.js-slider-next-cursor');
const $parallaxIngot = $('.js-parallax-ingot');
const $webglWrapParent = $('.js-webgl-wrap-parent');
/*let lastScroll = -1;*/

let notHover = false;

if ($numbersSlider.length && $numbersSlider.find('.swiper-slide').length) {
    initNumbersSlider();
}

if ($mainSlider.length) {
    initMainSlider();
    setSlideScheme();
}

if ($webglWrapParent.length) {
    App.W.on('scroll', throttle(function () {
        animateCube();
    }, 50));
}

function setSlideScheme() {
    const isDarkSlide = $mainSlider.find('.swiper-slide-active').is('.dark');

    if (isDarkSlide) {
        App.H.addClass('_dark-scheme');
    } else {
        App.H.removeClass('_dark-scheme');
    }
}

function initNumbersSlider() {
    new Swiper('.js-numbers-slider', {
        loop: true,
        mousewheel: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        threshold: 10,
        roundLengths: true,
        speed: 500,
        a11y: true
    });
}

function initMainSlider() {
    const mainSwiper = new Swiper('.js-main-slider', {
        loop: true,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination: {
            el: '.js-main-slider-pagination',
            clickable: true
        },
        threshold: 10,
        roundLengths: true,
        speed: 700,
        a11y: true
    });

    $textPagination.html(`1/${slidesCount}`);

    mainSwiper.on('slideChangeTransitionStart', function () {
        setSlideScheme();
        $textPagination.html(`${mainSwiper.realIndex + 1}/${slidesCount}`);
    });

    if ($prevBtnCursor.length && $nextBtnCursor.length) {
        const sliderEvent = App.mobile ? 'click' : 'mousemove click';

        $container.on(sliderEvent, throttle(function (e) {
            if (notHover) {
                return false;
            }

            const userEvent = e.type;
            const left = e.pageX;
            const top = e.pageY;

            if (e.target.nodeName === 'A' || e.target.nodeName === 'a') {
                disactiveHover();
                return false;
            }

            if (left < $mainSlider.outerWidth() * 0.3) {
                $container.addClass('_hover-cursor');

                if (userEvent === 'click') {
                    mainSwiper.slidePrev();
                } else {
                    $prevBtnCursor.css({
                        top: `${top}px`,
                        left: `${left}px`
                    }).addClass('_visible');
                }
            } else if (left > $mainSlider.outerWidth() * 0.7) {
                $container.addClass('_hover-cursor');
                $prevBtnCursor.removeClass('_visible');

                if (userEvent === 'click') {
                    mainSwiper.slideNext();
                } else {
                    $nextBtnCursor.css({
                        top: `${top}px`,
                        left: `${left}px`
                    }).addClass('_visible');
                }
            } else {
                disactiveHover();
            }
        }, 5));

        $container.on('mouseout', function () {
            setTimeout(function () {
                disactiveHover();
            }, 50);
        });

        $('.header').on('mouseover', function () {
            setTimeout(function () {
                disactiveHover();
            }, 50);
        });

        if (!App.mobile) {
            $mainSliderPagintaion.on('mouseover', function () {
                notHover = true;
                setTimeout(function () {
                    disactiveHover();
                }, 50);
            });

            $mainSliderPagintaion.on('mouseout', function () {
                notHover = false;
            });
        }
    }
}

function animateCube() {
    /*let direction;

    if (lastScroll < App.W.scrollTop()) {
        direction = 'down';
    } else {
        direction = 'up';
    }*/

    /*lastScroll = App.W.scrollTop();*/

    const scrollTop = App.W.scrollTop() + App.W.outerHeight() / 2;

    if (scrollTop > $webglWrapParent.offset().top && scrollTop < $webglWrapParent.offset().top + $webglWrapParent.outerHeight()) {
        let scrollPercent = 1 - ($webglWrapParent.offset().top + $webglWrapParent.outerHeight() - scrollTop) / $webglWrapParent.outerHeight();

        scrollPercent = parseFloat(scrollPercent.toFixed(2));

        $parallaxIngot.each(function (index, el) {
            const $currParallax = $(el);
            const currPixel = parseInt($currParallax.data('speed') * scrollPercent * $webglWrapParent.outerHeight());

            $currParallax.css({
                transform: `translateY(${currPixel}px)`
            });
        });
    }
}


// WEBPACK FOOTER //
// ./_src/js/MainPage.js